import { CircularProgress, Grid, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import {
  BucketAwtENUM,
  EstadosImagenChoiceEnum,
  extractIdsFromObjRes,
  gridSizeMdLg12,
  gridSizeMdLg6,
  useUploadFile,
} from '@/shared';
import {
  OrdenTrabajoQueryKeysEnum,
  UploadEntradaImagesOTData,
  useUpdateOrdenTrabajo,
} from '@/shared/actions/erp';
import { CustomPaperBox, SingleIconButton, TabTextLabel } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { ApiFileRespAWT, OrdenTrabajo, PhotosEntradaOTType } from '@/shared/interfaces';
import { useUploadImageStore } from '@/store/erp';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { useUploadImageComponent } from '../../../hooks/useUploadImageComponent';
import { useEffect, useState } from 'react';
import { ReplayOutlined } from '@mui/icons-material';

export type UploadFotosEntradaModalProps = {
  open: boolean;
  onClose: () => void;

  ordenTrabajo?: OrdenTrabajo;
};

const UploadFotosEntradaModal: React.FC<UploadFotosEntradaModalProps> = ({
  open,
  onClose,
  ordenTrabajo,
}) => {
  const queryClient = useQueryClient();
  const [showErrors, setShowErrors] = useState(false);
  const [reloadImages, setReloadImages] = useState(false);
  let TOTAL_FOTOS_ENTRADA = 6
  const PATH_BUCKET = `${BucketAwtENUM.IMAGE_INSTALACION}/${ordenTrabajo?.id_orden_trabajo}`
  // const TIPO_INTALACION_EXCLUDE_NORMAL = ordenTrabajo?.tipo_instalacion !=="NORMAL"
  // const PUNTOS_RED_INSTALADOS = parseInt(ordenTrabajo?.puntos_red_instalados || "0")
  // const ROUTER_ADICIONAL_INSTALADOS = parseInt(ordenTrabajo?.routers_adicionales_instalados || "0")*2
  // TOTAL_FOTOS_ENTRADA = 6 + PUNTOS_RED_INSTALADOS + ROUTER_ADICIONAL_INSTALADOS + (TIPO_INTALACION_EXCLUDE_NORMAL ? 1 : 0)

  ///* global state ------------
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  const setIsUploadingImgs = useUploadImageStore(s => s.setIsUploading);

  ///* custom hooks ------------
  const {
    UploadImageComponent,

    // fotoTipoInstalacion, setFotoTipoInstalacion,
    // fotoPuntosRedInstalados, setFotoPuntosRedInstalados,
    // fotoRouterAdicionalInstalados, setFotoRouterAdicionalInstalados,

    fotoNap,
    setFotoNap,
    fotoEtiquetaConector,
    setFotoEtiquetaConector,
    fotoEtiquetaChaqueta,
    setFotoEtiquetaChaqueta,
    fotoInteriorNap,
    setFotoInteriorNap,
    fotoPotenciaPuerto,
    setFotoPotenciaPuerto,
    fotoReversoONT,
    setFotoReversoONT,
  } = useUploadImageComponent();

  const { handleUploadFile } = useUploadFile();

  ///* mutations ------------
  const updateOT = useUpdateOrdenTrabajo<UploadEntradaImagesOTData>({
    enableRedirect: false,
    customSuccessMessage: 'Fotos de entrada cargadas correctamente',
  });

  ///* handlers ------------
  const handleUploadImages = async () => {

    // const estadoFotos = checkUploadedPhotos()
    
    let auxFotosEntrada:PhotosEntradaOTType = ordenTrabajo?.urls_fotos_entrada?.photosEntrada || {}
    let imagesIds:any[] = []
    setIsGlobalLoading(true);
    setIsUploadingImgs(true);


    const arrayFotosEntrada = [
      fotoNap && fotoNap?.name ? handleUploadFile(fotoNap, PATH_BUCKET) : null,
      fotoEtiquetaConector && fotoEtiquetaConector?.name ? handleUploadFile(fotoEtiquetaConector, PATH_BUCKET) : null,
      fotoEtiquetaChaqueta && fotoEtiquetaChaqueta?.name ? handleUploadFile(fotoEtiquetaChaqueta, PATH_BUCKET) : null,
      fotoInteriorNap && fotoInteriorNap?.name ? handleUploadFile(fotoInteriorNap, PATH_BUCKET) : null,
      fotoPotenciaPuerto && fotoPotenciaPuerto?.name ? handleUploadFile(fotoPotenciaPuerto, PATH_BUCKET) : null,
      fotoReversoONT && fotoReversoONT?.name ? handleUploadFile(fotoReversoONT, PATH_BUCKET) : null,
    ]


    const [
      fotoNapRes,
      fotoEtiquetaConectorRes,
      fotoEtiquetaChaquetaRes,
      fotoInteriorNapRes,
      fotoPotenciaPuertoRes,
      fotoReversoONTRes,
    ] = await Promise.all(arrayFotosEntrada);
    

    const filterArrayFotosEntrada = [ 
      fotoNapRes, 
      fotoEtiquetaConectorRes, 
      fotoEtiquetaChaquetaRes, 
      fotoInteriorNapRes, 
      fotoPotenciaPuertoRes, 
      fotoReversoONTRes 
    ].map((item, index) => {
        if(!!item){
          return item
        }else{
          switch (index) {
            case 0:
              return ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoNap?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoNap?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoNap?.photoId,
              }
              : null
            case 1:
              return ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaConector?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaConector?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaConector?.photoId,
              }
              : null
            case 2:
              return ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaChaqueta?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaChaqueta?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaChaqueta?.photoId,
              }
              : null
            case 3:
              return ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoInteriorNap?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoInteriorNap?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoInteriorNap?.photoId,
              }
              : null
            case 4:
              return ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoPotenciaPuerto?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoPotenciaPuerto?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoPotenciaPuerto?.photoId,
              }
              : null
            case 5:
              return ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoReversoONT?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoReversoONT?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoReversoONT?.photoId,
              }
              : null
            default:
              return null
          }
      }
    })
    // console.log({filterArrayFotosEntrada})

    const auxImagesIds = filterArrayFotosEntrada.map((item) => {
      if(!!item){
        return extractIdsFromObjRes([item as ApiFileRespAWT])?.[0]
      }else{
        return null
      }
    })


    imagesIds = [ ...imagesIds, ...auxImagesIds];
    // console.log({imagesIds})

    auxFotosEntrada = {
      ...auxFotosEntrada,
      fotoNap: {
        photoUrl: fotoNapRes?.url || filterArrayFotosEntrada[0]?.url || null,
        photoId: fotoNapRes?.id_archivos || filterArrayFotosEntrada[0]?.id_archivos || null,
        photoName: 'Foto NAP',
      },
      fotoEtiquetaConector: {
        photoUrl: fotoEtiquetaConectorRes?.url || filterArrayFotosEntrada[1]?.url || null,
        photoId: fotoEtiquetaConectorRes?.id_archivos || filterArrayFotosEntrada[1]?.id_archivos || null,
        photoName: 'Foto Etiqueta en Conector',
      },
      fotoEtiquetaChaqueta: {
        photoUrl: fotoEtiquetaChaquetaRes?.url || filterArrayFotosEntrada[2]?.url || null,
        photoId: fotoEtiquetaChaquetaRes?.id_archivos || filterArrayFotosEntrada[2]?.id_archivos || null,
        photoName: 'Foto Etiqueta en Chaqueta',
      },
      fotoInteriorNap: {
        photoUrl: fotoInteriorNapRes?.url || filterArrayFotosEntrada[3]?.url || null,
        photoId: fotoInteriorNapRes?.id_archivos || filterArrayFotosEntrada[3]?.id_archivos || null,
        photoName: 'Foto Interior NAP',
      },
      fotoPotenciaPuerto: {
        photoUrl: fotoPotenciaPuertoRes?.url || filterArrayFotosEntrada[4]?.url || null,
        photoId: fotoPotenciaPuertoRes?.id_archivos || filterArrayFotosEntrada[4]?.id_archivos || null,
        photoName: 'Foto Potencia Puerto',
      },
      fotoReversoONT: {
        photoUrl: fotoReversoONTRes?.url || filterArrayFotosEntrada[5]?.url || null,
        photoId: fotoReversoONTRes?.id_archivos || filterArrayFotosEntrada[5]?.id_archivos || null,
        photoName: 'Foto Reverso ONT',
      },
    }
    // if(ordenTrabajo?.tipo_instalacion !=="NORMAL"){
    //   auxFotosEntrada.fotoTipo = {
    //     photoUrl: fotoCableadoInternoFORes.url,
    //     photoId: fotoCableadoInternoFORes.id_archivos,
    //     photoName: 'Foto Cableado Interno FO',
    //   }
    // }


    onClose();

    // console.log(imagesIds.filter((id)=>!!id).length)
    // console.log(TOTAL_FOTOS_ENTRADA)
    updateOT.mutateAsync({
      id: ordenTrabajo?.id_orden_trabajo!,
      data: {
        estado_imagen_entrada: imagesIds.filter((id)=>!!id).length === TOTAL_FOTOS_ENTRADA? 
        EstadosImagenChoiceEnum.CARGADO : EstadosImagenChoiceEnum.NO_CARGADO,
        urls_fotos_entrada: {
          id_images_entrada: imagesIds,
          photosEntrada: auxFotosEntrada,
        },
      },
    })

    await queryClient.invalidateQueries({
      queryKey: [OrdenTrabajoQueryKeysEnum.OrdenesTrabajo],
    });

    setIsGlobalLoading(false);
    setIsUploadingImgs(false);
  };


  //Para cuando lo pidan la validación por nombres
  // const checkUploadedPhotos = () => {
  //   let photos = [
  //     {
  //       foto: "fotoNap",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoNap?.photoUrl,
  //     },
      
  //     {
  //       foto: "fotoReversoONT",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoReversoONT?.photoUrl,
  //     },
      
  //     {
  //       foto: "fotoInteriorNap",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoInteriorNap?.photoUrl,
  //     },
      
  //     {
  //       foto: "fotoPotenciaPuerto",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoPotenciaPuerto?.photoUrl,
  //     },
      
  //     {
  //       foto: "fotoEtiquetaChaqueta",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaChaqueta?.photoUrl,
  //     },
      
  //     {
  //       foto: "fotoEtiquetaConector",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoEtiquetaConector?.photoUrl,
  //     },
  //     {
  //       foto: "fotoTipoInstalacion",
  //       estado: !!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotoTipoInstalacion?.photoUrl,
  //     },
  //   ]
  //   if(!ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotosAdicionales){
  //     console.log({photos})
  //     return photos
  //   }
  //   const puntosRed = Object.values(ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotosAdicionales?.fotoPuntosRedInstalados||{})
  //   if(puntosRed.length > 0){
  //     puntosRed.forEach((fotoPuntosRedInstalados, index)=>{
  //       photos.push({
  //         foto: `puntoRed${index+1}`,
  //         estado: !!fotoPuntosRedInstalados?.photoUrl,
  //       })
  //     })
  //   }
  //   const routersAdicionales = Object.values(ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.fotosAdicionales?.fotoRoutersAdicionalesInstalados||{})
  //   if(routersAdicionales.length > 0){
  //     routersAdicionales.forEach((fotoRouterAdicionalInstalados, index)=>{
  //       photos.push({
  //         foto: `routerAdicional${index+1}`,
  //         estado: !!fotoRouterAdicionalInstalados?.photoUrl,
  //       })
  //     })
  //   }
  //   console.log({photos})
    
  //   return photos
    
  // }
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );
  const removePhoto = async (photoKey: keyof PhotosEntradaOTType) => {
    setConfirmDialog({
      isOpen: true,
      subtitle: "Al dar clic en confirmar, se procederá a eliminar la foto. ¿Desea continuar?",
      title: "Eliminar Foto",
      onConfirm: async() => {
        setIsGlobalLoading(true);
        if(!photoKey?.length){
          return
        }
        const itemPhoto = ordenTrabajo?.urls_fotos_entrada?.photosEntrada?.[photoKey]
        if(itemPhoto){
          const photoId = itemPhoto.photoId
          itemPhoto.photoId = null
          itemPhoto.photoUrl = null
          itemPhoto.photoName = null
          const newIdImagesEntrada = ordenTrabajo?.urls_fotos_entrada?.id_images_entrada?.map((id) => {
            if(id === photoId){
              return null
            }
            return id
          })
          await updateOT?.mutateAsync({
            id: ordenTrabajo?.id_orden_trabajo!,
            data: {
              estado_imagen_entrada: newIdImagesEntrada?.filter((id)=>!!id).length === TOTAL_FOTOS_ENTRADA? 
                EstadosImagenChoiceEnum.CARGADO 
                : EstadosImagenChoiceEnum.NO_CARGADO,
              urls_fotos_entrada: {
                photosEntrada:{
                  ...ordenTrabajo?.urls_fotos_entrada?.photosEntrada,
                  [photoKey]: itemPhoto
                },
                id_images_entrada: newIdImagesEntrada!
              }
            }
          },{
            onSuccess: async () => {
              await queryClient.invalidateQueries({
                queryKey: [OrdenTrabajoQueryKeysEnum.OrdenesTrabajo],
              });
              setIsGlobalLoading(false);
            },
            onSettled: () => {
              setIsGlobalLoading(false);
            },
            onError: () => {
              setIsGlobalLoading(false);
            }
          })
        }
        setConfirmDialogIsOpen(false)
      },
      onClose() {
        setConfirmDialogIsOpen(false);
      },
    });

  }

  useEffect(() => {
    if(showErrors){
      setTimeout(() => {
        setShowErrors(false)
      }, 5000);
    }
  }, [
    fotoNap,
    fotoEtiquetaConector,
    fotoEtiquetaChaqueta,
    fotoInteriorNap,
    fotoPotenciaPuerto,
    fotoReversoONT
  ]);

  const fotosEntrada = ordenTrabajo?.urls_fotos_entrada?.photosEntrada

  useEffect(() => {
    setTimeout(() => {
      setReloadImages(false)
    }, 1000);
  }, [reloadImages])

  return (
    <>
      <ScrollableDialogProps
        open={open}
        title="Cargar Fotos Entrada"
        minWidth="54%"
        minHeight="30vh"
        contentNode={
          <>
            <Grid {...gridSizeMdLg12} container alignItems="center">
              <Grid {...gridSizeMdLg6} container item justifyContent="left" p={2}>
                <Typography variant="body1" fontWeight={700} textAlign="left">
                  Tiene {ordenTrabajo?.urls_fotos_entrada?.id_images_entrada?.filter((id)=>id!==null)?.length || 0} de {TOTAL_FOTOS_ENTRADA} fotos cargadas</Typography>
              </Grid>
              <Grid {...gridSizeMdLg6} container item justifyContent="right" p={2}>
                <SingleIconButton
                  startIcon={<ReplayOutlined />}
                  color="info"
                  label={'Refrescar Fotos Entrada'}
                  onClick={async () => {
                    setReloadImages(true)
                    await queryClient.invalidateQueries({
                      queryKey: [OrdenTrabajoQueryKeysEnum.OrdenesTrabajo],
                    });
                  }}
                />
              </Grid>
            </Grid>
            <CustomPaperBox sxPaper={{ mb: 6 }}>
              <Grid item container spacing={3} justifyContent="center">
                <TabTextLabel text="Fotos de entrada" />
                {
                  reloadImages?
                    <CircularProgress color="inherit" />
                  :
                  <>
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto NAP'}
                        selectedImage={fotoNap}
                        setSelectedImage={setFotoNap}
                        idInput={'entrada-nap'}
                        imageUrl={fotosEntrada?.fotoNap?.photoUrl||""}
                        onRemoveImage={() => {
                          removePhoto('fotoNap')
                        }}
                      />
                      {showErrors && !fotoNap?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto NAP es requerida</Typography>
                      :null}
                    </Grid>
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto Etiqueta en Conector'}
                        selectedImage={fotoEtiquetaConector}
                        setSelectedImage={setFotoEtiquetaConector}
                        idInput={'etiqueta-conector'}
                        imageUrl={fotosEntrada?.fotoEtiquetaConector?.photoUrl||""}
                        onRemoveImage={() => {
                          removePhoto('fotoEtiquetaConector')
                        }}
                      />
                      {showErrors && !fotoEtiquetaConector?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto Etiqueta en Conector es requerida</Typography>
                      :null}
                    </Grid>
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto Etiqueta en Chaqueta'}
                        selectedImage={fotoEtiquetaChaqueta}
                        setSelectedImage={setFotoEtiquetaChaqueta}
                        idInput={'etiqueta-chaqueta'}
                        imageUrl={fotosEntrada?.fotoEtiquetaChaqueta?.photoUrl||""}
                        onRemoveImage={() => {
                          removePhoto('fotoEtiquetaChaqueta')
                        }}
                      />
                      {showErrors && !fotoEtiquetaChaqueta?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto Etiqueta en Chaqueta es requerida</Typography>
                      :null}
                    </Grid>
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto Interior NAP'}
                        selectedImage={fotoInteriorNap}
                        setSelectedImage={setFotoInteriorNap}
                        idInput={'interior-nap'}
                        imageUrl={fotosEntrada?.fotoInteriorNap?.photoUrl||""}
                        onRemoveImage={() => {
                          removePhoto('fotoInteriorNap')
                        }}
                      />
                      {showErrors && !fotoInteriorNap?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto Interior NAP es requerida</Typography>
                      :null}
                    </Grid>
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto Potencia Puerto'}
                        selectedImage={fotoPotenciaPuerto}
                        setSelectedImage={setFotoPotenciaPuerto}
                        idInput={'potencia-puerto'}
                        imageUrl={fotosEntrada?.fotoPotenciaPuerto?.photoUrl||""}
                        onRemoveImage={() => {
                          removePhoto('fotoPotenciaPuerto')
                        }}
                      />
                      {showErrors && !fotoPotenciaPuerto?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto PON ONT es requerida</Typography>
                      :null}
                    </Grid>
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto Reverso ONT'}
                        selectedImage={fotoReversoONT}
                        setSelectedImage={setFotoReversoONT}
                        idInput={'reverso-ont'}
                        imageUrl={fotosEntrada?.fotoReversoONT?.photoUrl||""}
                        onRemoveImage={() => {
                          removePhoto('fotoReversoONT')
                        }}
                      />
                      {showErrors && !fotoReversoONT?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto Reverso ONT es requerida</Typography>
                      :null}
                    </Grid>
                  </>
                }

                
              </Grid>
            </CustomPaperBox>

    


            {/* <CustomPaperBox sxPaper={{ mb: 6 }}>
              <Grid item container spacing={3} justifyContent="center">
                <TabTextLabel text="Fotos Adicionales" />
                <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center">
                  {
                    ordenTrabajo?.tipo_instalacion !=="NORMAL" && (
                    <Grid item {...gridSizeMdLg6}>
                      <UploadImageComponent
                        buttonText={'Foto Tipo Instalación'}
                        selectedImage={fotoTipoInstalacion}
                        setSelectedImage={setFotoTipoInstalacion}
                        idInput={'entrada-tipo-instalacion'}
                        imageUrl={fotosEntrada?.fotoTipoInstalacion?.photoUrl||""}
                      />
                      {showErrors && !fotoTipoInstalacion?
                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto Tipo Instalación es requerida</Typography>
                      :null}
                    </Grid>
                    )
                  }
                </Grid>


                <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center">
                  {
                    parseInt(ordenTrabajo?.puntos_red_instalados || "0") > 0 && (<>
                      <TabTextLabel text="Fotos Puntos de Red Instalados" />
                        {
                          Array.from({ length: parseInt(ordenTrabajo?.puntos_red_instalados||"0") }, (_, i) => i).map((item)=>
                          <Grid item {...gridSizeMdLg6}>
                            <UploadImageComponent
                              key={item+"_puntos-red"}
                              buttonText={'Punto de Red '+(item+1)}
                              selectedImage={fotoPuntosRedInstalados||null}
                              setSelectedImage={setFotoPuntosRedInstalados}
                              indexPhoto={item}
                              idInput={'entrada-puntos-red-'+item}
                              imageUrl={fotosEntrada?.fotosAdicionales?.fotoPuntosRedInstalados?.[`puntoRed${item+1}`]?.photoUrl||""}
                            />
                            {showErrors && !fotoPuntosRedInstalados?.[item]?
                            <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>{"La Foto Punto de Red "+(item+1)+" es requerida"}</Typography>
                            :null}
                          </Grid>
                          )
                        }
                    </>
                    )
                  }
                </Grid>

                  {
                    parseInt(ordenTrabajo?.routers_adicionales_instalados || "0") > 0 && (<>
                      <TabTextLabel text="Fotos Routers Adicionales Instalados" />
                        {
                          fotoRouterAdicionalInstalados?.map((_,index)=>
                          <>
                            <Grid item {...gridSizeMdLg6}>
                              <UploadImageComponent
                                key={index+"_routers-adicionales"}
                                buttonText={`Router Adicional ${Math.floor(index / 2) + 1}${index % 2 === 0 ? 'A' : 'B'}`}
                                selectedImage={fotoRouterAdicionalInstalados||null}
                                setSelectedImage={setFotoRouterAdicionalInstalados}
                                indexPhoto={index}
                                idInput={'entrada-router-adicional-a-'+(index)}
                                imageUrl={fotosEntrada?.fotosAdicionales?.fotoRoutersAdicionalesInstalados?.[`routerAdicional${index+1}`]?.photoUrl||""}
                              />
                              {showErrors && !fotoRouterAdicionalInstalados?.[index]?
                              <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>{"La Foto Router Adicional "+(index+1)+" A es requerida"}</Typography>
                              :null}
                            </Grid>
                          </>
                          )
                        }
                    </>
                    )
                  }

              </Grid>
            </CustomPaperBox> */}
          </>
        }
        onClose={onClose}
        onConfirm={handleUploadImages}
        confirmTextBtn="Cargar Fotos"
        confirmVariantBtn="outlined"
      />
    </>
  );
};

export default UploadFotosEntradaModal;
